function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import includes from 'lodash/includes';
import filter from 'lodash/filter';
import pick from 'lodash/pick';
import keys from 'lodash/keys';
import history from 'helpers/history';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import App from 'modules/App';
import { useAction } from 'hooks';
import CountryCodeFormPartial from 'components/CountryCodeFormPartial';
import { AppContext } from 'context';
import Password from '../../../partials/Password';
import * as actions from '../../../actions';
import { SIGN_UP_FORM } from '../../../constants';
import messages from '../../../messages';
import { getStepValidationRules } from '../helpers';
import { useSetCountry } from '../hooks/useSetCountry';
import MobileConsentModal from '../MobileConsentModal';
import Actions from './Actions';
import TermsOfServiceAndPrivacy from './TermsOfServiceAndPrivacy';
import { useIsMinor, useFormatFormValuesForSubmit } from './hooks';
import GuardianConsentsEmail from './GuardianConsentsEmail';
const FillData = ({ allowedCountryCodes, isFieldDisabled, onSetCredentialFormValue, onBack })=>{
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const countries = useSelector(App.selectors.countries);
    const signUp = useAction(actions.signUp);
    const scope = get(formValues, 'values.scope');
    const values = get(formValues, 'values');
    const { getUrl } = useContext(AppContext);
    const isMinor = useIsMinor();
    const [stepValidatorRules, setStepValidatorRules] = useState(_object_spread({}, getStepValidationRules('FillData', scope), isMinor ? getStepValidationRules('FillData', 'MinorPersonal') : {}));
    const stepValues = {
        values: pick(values, keys(stepValidatorRules))
    };
    const allowedCountries = filter(countries, (c)=>includes(c.availableScopes, scope) && (!allowedCountryCodes || includes(allowedCountryCodes, c.alpha2Code)));
    const setCountry = useSetCountry();
    const isFormNotCompleted = App.hooks.useIsFormNotCompleted(stepValues, stepValidatorRules);
    const isPasswordValid = App.hooks.useIsPasswordValid(stepValues, stepValidatorRules);
    const formatFormValuesForSubmit = useFormatFormValuesForSubmit();
    const submitForm = (validatedValues)=>{
        if (validatedValues.guardianEmail) {
            const url = `${getUrl('confirm-guardian-email-mock')}?email=${validatedValues.guardianEmail}`;
            history.push(url);
        } else {
            signUp(formatFormValuesForSubmit(validatedValues));
        }
    };
    const processForm = App.hooks.useFormProcessing(SIGN_UP_FORM, submitForm, {
        stopOnFirstError: false
    });
    const onSubmit = ()=>{
        processForm(stepValues, stepValidatorRules);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Form, {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ _jsx(CountryCodeFormPartial, {
                        countries: allowedCountries,
                        formValues: formValues,
                        isDisabled: isFieldDisabled('countryCode'),
                        onSetFormValue: (input)=>setCountry(input, get(formValues, 'values.appSKUCountryCode'))
                    }),
                    /*#__PURE__*/ _jsx(FormGroup, {
                        id: "email",
                        labelMessage: messages.labels.email,
                        formValues: formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: messages.placeholders.email,
                            isDisabled: isFieldDisabled('email'),
                            onChange: onSetCredentialFormValue
                        })
                    }),
                    /*#__PURE__*/ _jsx(Password, {
                        id: "password",
                        labelMessage: messages.labels.password,
                        formValues: formValues,
                        onChange: onSetCredentialFormValue
                    }),
                    /*#__PURE__*/ _jsx(TermsOfServiceAndPrivacy, {
                        stepValidatorRules: stepValidatorRules,
                        setStepValidatorRules: setStepValidatorRules
                    }),
                    /*#__PURE__*/ _jsx(GuardianConsentsEmail, {}),
                    /*#__PURE__*/ _jsx(Actions, {
                        stepValidatorRules: stepValidatorRules,
                        isContinueDisabled: isFormNotCompleted || !isPasswordValid,
                        onBack: onBack
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MobileConsentModal, {})
        ]
    });
};
export default FillData;
